import { isValid, parseISO } from "date-fns";
import { isCustomerTooOld, isCustomerTooYoung, tooOldMessage, tooYoungMessage, toISODate, DOB_MUST_BE_IN_PAST_MESSAGE, PHONE_NUMBERS, FUNNEL_NAMES, INTERNATIONAL_FUNNELS, iapTooYoungMessage, iapTooOldMessage } from "../utils/common";
import { isValidDate } from "./validDate";
var validDateOfBirth = function validDateOfBirth(value) {
  var maxYearsAgo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var minYearsAgo = arguments.length > 2 ? arguments[2] : undefined;
  var funnel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ARHI";
  var isDependant = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isPartner = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var customApplicantType = arguments.length > 6 ? arguments[6] : undefined;
  if (!value || !isValidDate(value)) {
    return "Please enter a valid date of birth.";
  }
  var isoDateString = toISODate(value);
  var dateDob = parseISO(isoDateString);
  var today = new Date();
  var funnelPhone = PHONE_NUMBERS[funnel];
  var funnelName = FUNNEL_NAMES[funnel];
  var isARHIorWhitelabel = !INTERNATIONAL_FUNNELS.includes(funnel);
  var otherApplicationType = maxYearsAgo === 25 ? "dependants" : "applicants";
  var arhiorWhitelabelApplicationType = isDependant ? "dependants" : "applicants";
  var applicationType = isARHIorWhitelabel ? arhiorWhitelabelApplicationType : otherApplicationType;
  var errors;
  if (!isValid(dateDob)) {
    errors = "Please enter a valid date of birth.";
  } else {
    if (dateDob > today) {
      errors = isDependant && isARHIorWhitelabel ? "This date of birth is in the future. If you're trying to add your unborn baby to your policy, you'll need to call us on ".concat(funnelPhone, ".") : DOB_MUST_BE_IN_PAST_MESSAGE;
    } else {
      // too young.
      if (minYearsAgo && isCustomerTooYoung(isoDateString, minYearsAgo)) {
        errors = funnel !== "IAP" ? tooYoungMessage(minYearsAgo, funnelName, funnelPhone, funnel, isDependant, isPartner) : iapTooYoungMessage(minYearsAgo, isPartner, customApplicantType);
      } // too old
      if (isCustomerTooOld(isoDateString, maxYearsAgo)) {
        errors = funnel !== "IAP" ? tooOldMessage(applicationType, maxYearsAgo, funnelName, funnelPhone, funnel, isDependant, isPartner) : iapTooOldMessage(maxYearsAgo, isDependant, isPartner, customApplicantType);
      }
    }
  }
  return errors;
};
export default validDateOfBirth;